import { createAction } from "redux-actions";
import { createPromiseAction } from "../../utils/createPromiseAction";

export const GET_COLUMNS_REQUEST = "brand/GET_COLUMNS_REQUEST";
export const GET_COLUMNS_SUCCESS = "brand/GET_COLUMNS_SUCCESS";
export const GET_ORGA_TASKS_REQUEST = "brand/GET_ORGA_TASKS_REQUEST";
export const GET_ORGA_TASKS_SUCCESS = "brand/GET_ORGA_TASKS_SUCCESS";
export const SILENT_TASKS_UPDATE = "brand/SILENT_TASKS_UPDATE";

export const orgaActions = {
  getColumns: createPromiseAction(GET_COLUMNS_REQUEST),
  getColumnsSuccess: createAction(GET_COLUMNS_SUCCESS),
  getTasks: createPromiseAction(GET_ORGA_TASKS_REQUEST),
  getTasksSuccess: createAction(GET_ORGA_TASKS_SUCCESS),
  silentTasksUpdate: createAction(SILENT_TASKS_UPDATE),
};
